import { useQuery } from 'react-query';

import { GetSubsetOverviewResponseDto } from '../../../../backend/src/case/subset/dto/get-subset-overview.response.dto';
import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import { GetCaseOverviewRes } from '@/api/types/queries';
import useGetFetchConfig from '@/api/useGetFetchConfig';

const useGetSubsetOverview = (matterId: string | null, subsetId: string | null) => {
  const { fetchConfigGET } = useGetFetchConfig();

  const getSubsetOverview = async (): Promise<GetSubsetOverviewResponseDto> => {
    const response = await fetch(
      `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/overview`,
      fetchConfigGET,
    );
    if (!response.ok) {
      throw new Error('Fetching subset overview failed');
    }

    return response.json();
  };

  return useQuery([QueryEntity.SubsetOverview, matterId, subsetId], getSubsetOverview, {
    enabled: !!matterId && !!subsetId,
    refetchOnWindowFocus: false,
  });
};

export default useGetSubsetOverview;
